const MEDIA_REF_PREFIX = 'api/media';

function getMediaRef(id: number) {
  return `${MEDIA_REF_PREFIX}/${id}`;
}

export default getMediaRef;
